import TagManager from 'react-gtm-module'

/**
 * Wrapper central do Google Tag Manager.
 *
 * Toda chamada vira no-op se REACT_APP_GTM não estiver definida (só setada em
 * .env.prod — dev/QA nunca disparam GTM), mesmo padrão do mixpanel.ts.
 */

const GTM_ID = 'GTM-KF5XH378'

let inicializado = false

const habilitado = (): boolean => !!process.env.REACT_APP_GTM

export const inicializarGtm = (): void => {
  if (!habilitado() || inicializado) return
  TagManager.initialize({ gtmId: GTM_ID })
  inicializado = true
}

/** Envia um evento ao dataLayer sem reinjetar o script do GTM. */
export const enviarEventoGtm = (dataLayer: Record<string, unknown>): void => {
  if (!habilitado() || !inicializado) return
  TagManager.dataLayer({ dataLayer })
}
